module.exports = __webpack_public_path__ + "img/kefuri-app.1463078c.png";